import StaffProgress from "./StaffProgress";

export default StaffProgress;